import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SHIPPING_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the shipping fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @param {boolean} [props.showShippingFeePlaceholder] - Show select-method copy when no fee exists
 * @returns {JSX.Element}
 */
const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl, showShippingFeePlaceholder = false } = props;

  const shippingFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );
  const amount = shippingFeeLineItem?.lineTotal?.amount;
  const showPlaceholder = showShippingFeePlaceholder && !(amount > 0);

  if (!shippingFeeLineItem && !showPlaceholder) {
    return null;
  }

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={css.itemValue}>
        {showPlaceholder ? (
          <FormattedMessage id="OrderBreakdown.pleaseSelectShippingMethod" />
        ) : (
          formatMoney(intl, shippingFeeLineItem.lineTotal)
        )}
      </span>
    </div>
  );
};

export default LineItemShippingFeeMaybe;
